// Per-device notification preferences (stored in localStorage — notification
// behavior is naturally device-specific). Defaults: sound on, desktop off.

export const notifPrefs = {
  sound: () => localStorage.getItem('ecd_notif_sound') !== '0',
  desktop: () => localStorage.getItem('ecd_notif_desktop') === '1',
  setSound: (v: boolean) => localStorage.setItem('ecd_notif_sound', v ? '1' : '0'),
  setDesktop: (v: boolean) => localStorage.setItem('ecd_notif_desktop', v ? '1' : '0')
};

/** Play a sound only if the agent hasn't muted notifications. */
export const playIfEnabled = (audio: HTMLAudioElement) => {
  try {
    if (notifPrefs.sound()) void audio.play();
  } catch {
    /* autoplay may be blocked until interaction */
  }
};

/** Show a desktop notification if enabled, permitted, and the tab is hidden. */
export const showDesktopNotification = (title: string, body?: string) => {
  try {
    if (!notifPrefs.desktop()) return;
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
    if (!document.hidden) return; // only when the agent isn't already looking
    new Notification(title, { body, icon: 'https://easychatdesk.com/images/avatar.png' });
  } catch {
    /* noop */
  }
};
